import { Link, NavLink, Outlet } from 'react-router-dom'
import { useApiQuery } from 'grabbitbot-legacy-ui'
import { adminFinance } from '../api/finance'
import { scopeOptions } from '../lib/financeMode'
import { formatCount } from '../lib/money'
import { useFinance } from './financeContext'
import { Chip } from './ui'

const NAV: { heading: string; items: { to: string; label: string; end?: boolean; badge?: boolean }[] }[] = [
  {
    heading: 'Pénzügy',
    items: [
      { to: '/admin/finance', label: 'Áttekintés', end: true },
      { to: '/admin/finance/problems', label: 'Figyelmet igényel', badge: true },
    ],
  },
  { heading: 'Felhasználók', items: [{ to: '/admin/finance/users', label: 'Felhasználó-kereső' }] },
  {
    heading: 'Napló',
    items: [
      { to: '/admin/finance/stripe-log', label: 'Stripe-napló' },
      { to: '/admin/finance/admin-operations', label: 'Admin-műveletek' },
    ],
  },
  { heading: 'Egyéb', items: [{ to: '/admin/finance/help', label: 'Súgó' }] },
]

function NoAccess() {
  return (
    <div className="af-card" role="alert" data-testid="no-access">
      <h1>Nincs jogosultság</h1>
      <p>Az admin pénzügyi nézethez projekt-admin vagy globális admin jog kell. Ha ennek ellenére szükséged lenne rá, kérd a projekt tulajdonosát.</p>
      <p>
        <Link to="/projects">Vissza a projektekhez</Link>
      </p>
    </div>
  )
}

/** Frame of every `/admin/finance/*` page: guard (scope must allow it — a
 * 403/failed scope renders "Nincs jogosultság", never an empty dashboard),
 * the Admin menu and the project scope selector. */
export function AdminFinanceLayout() {
  const fin = useFinance()
  const problems = useApiQuery(
    () => (fin.scope && fin.visible ? adminFinance.problems(fin.projectId) : Promise.resolve(null)),
    [fin.visible, fin.projectId],
  )
  if (fin.scopeLoading) return <p className="portal-text-muted">Betöltés…</p>
  if (!fin.visible || !fin.scope) return <NoAccess />
  const options = scopeOptions(fin.scope)
  const counts = problems.data?.counts
  const total = counts ? Object.values(counts).reduce<number>((a, n) => a + (typeof n === 'number' ? n : 0), 0) : null

  return (
    <div className="af-layout">
      <nav className="af-nav" aria-label="Admin menü">
        {NAV.map((g) => (
          <div key={g.heading} className="af-nav__group">
            <div className="af-nav__heading">{g.heading}</div>
            {g.items.map((i) => (
              <NavLink key={i.to} to={i.to} end={i.end} className={({ isActive }) => (isActive ? 'af-navlink af-navlink--on' : 'af-navlink')}>
                {i.label}
                {i.badge && total !== null && total > 0 && <Chip tone="crit">{formatCount(total)}</Chip>}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
      <main className="af-main">
        <div className="af-scope">
          <label>
            Hatókör
            <select aria-label="Projekt" value={fin.selection} onChange={(e) => fin.setSelection(e.target.value)}>
              {options.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </select>
          </label>
        </div>
        <Outlet />
      </main>
    </div>
  )
}
